import React, { Component } from 'react'
import Utils from '../../libs/Utils'
import EstimationStore from '../../libs/EstimationStore'
import EstimationActions from '../../libs/EstimationActions'

class SocialInsuranceUchiwake extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation(),
      laborType: this.props.laborType,
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  render () {
    let dt = EstimationActions.getLaborSharedValues(this.state.laborType)
    const isShowShien = dt.laborKoyounushiKodomoShienRyouritsu > 0

    return (
      <div className='kw-detail'>

        <table>
          <thead>
            <tr>
              <th className='kw-expense-name' />
              <th className='kw-expense-total-yen' />
              <th className='kw-expense-rate' />
              <th className='kw-expense-yen' />
              <th className='kw-expense-rate' />
              <th className='kw-expense-yen' />
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className='kw-bottom-double' rowSpan='2' />
              <th className='kw-bottom-double' rowSpan='2'>保険対象額</th>
              <th colSpan='2'>本人負担分</th>
              <th colSpan='2'>雇用主負担分</th>
            </tr>
            <tr>
              <th className='kw-bottom-double'>負担率</th>
              <th className='kw-bottom-double'>負担額</th>
              <th className='kw-bottom-double'>負担率</th>
              <th className='kw-bottom-double'>負担額</th>
            </tr>
            <tr>
              <td className='kw-top-double text-left'>厚生年金</td>
              <td className='kw-top-double'>{Utils.convKingaku(dt.honninNenkinHyouzhunGetsugaku)}</td>
              <td className='kw-top-double'>{Utils.convSuuryou(dt.laborHonninNenkinRyouritsu * 100, 3)}%</td>
              <td className='kw-top-double'>{Utils.convKingaku(dt.laborHonninNenkin)}</td>
              <td className='kw-top-double'>{Utils.convSuuryou(dt.laborHonninNenkinRyouritsu * 100, 3)}%</td>
              <td className='kw-top-double'>{Utils.convKingaku(dt.laborHonninNenkin)}</td>
            </tr>
            <tr>
              <td className='text-left'>健康保険</td>
              <td rowSpan={isShowShien ? '4' : '3'}>{Utils.convKingaku(dt.honninKenkouHyouzyunGetsugaku)}</td>
              <td>{Utils.convSuuryou(dt.laborHonninKenkouRyouritsu * 100, 3)}%</td>
              <td>{Utils.convKingaku(dt.laborHonninKenkou)}</td>
              <td>{Utils.convSuuryou(dt.laborHonninKenkouRyouritsu * 100, 3)}%</td>
              <td>{Utils.convKingaku(dt.laborHonninKenkou)}</td>
            </tr>
            <tr>
              <td className='text-left'>介護保険</td>
              <td>{Utils.convSuuryou(dt.laborHonninKaigoRyouritsu * 100, 3)}%</td>
              <td>{Utils.convKingaku(dt.laborHonninKaigo)}</td>
              <td>{Utils.convSuuryou(dt.laborHonninKaigoRyouritsu * 100, 3)}%</td>
              <td>{Utils.convKingaku(dt.laborHonninKaigo)}</td>
            </tr>
            <tr>
              <td className='text-left'>子ども・子育て拠出金</td>
              <td className='kw-ln' />
              <td className='kw-ln' />
              <td>{Utils.convSuuryou(dt.laborKoyounushiKodomoRyouritsu * 100, 3)}%</td>
              <td>{Utils.convKingaku(dt.laborKoyounushiKodomo)}</td>
            </tr>
            {isShowShien && (
            <tr>
              <td className='text-left'>子ども・子育て支援金</td>
              <td>{Utils.convSuuryou(dt.laborKoyounushiKodomoShienRyouritsu * 100, 3)}%</td>
              <td>{Utils.convKingaku(dt.laborKoyounushiKodomoShien)}</td>
              <td>{Utils.convSuuryou(dt.laborKoyounushiKodomoShienRyouritsu * 100, 3)}%</td>
              <td>{Utils.convKingaku(dt.laborKoyounushiKodomoShien)}</td>
            </tr>
            )}
            <tr>
              <td className='kw-bottom-double text-left'>雇用保険</td>
              <td className='kw-bottom-double'>{Utils.convKingaku(dt.getsugaku)}</td>
              <td className='kw-bottom-double'>{Utils.convSuuryou(dt.laborHonninKoyouRyouritsu * 100, 3)}%</td>
              <td className='kw-bottom-double'>{Utils.convKingaku(dt.laborHonninKoyou)}</td>
              <td className='kw-bottom-double'>{Utils.convSuuryou(dt.laborKoyounushiKoyouRyouritsu * 100, 3)}%</td>
              <td className='kw-bottom-double'>{Utils.convKingaku(dt.laborKoyounushiKoyou)}</td>
            </tr>
            <tr>
              <td className='kw-top-double text-left' colSpan='2'>合計</td>
              <td className='kw-top-double'>{Utils.convSuuryou(dt.honninRyouritsu * 100, 3)}%</td>
              <td className='kw-top-double'>{Utils.convKingaku(dt.honninGoukei)}</td>
              <td className='kw-top-double'>{Utils.convSuuryou(dt.koyounushiRyouritsu * 100, 3)}%</td>
              <td className='kw-top-double'>{Utils.convKingaku(dt.koyonusiGoukei)}</td>
            </tr>
            <tr>
              <td className='text-left' colSpan='2'>日額社会保険料(金額ベース)</td>
              <td />
              <td>{Utils.convKingaku(dt.honninGoukei / dt.laborWorkDays)}</td>
              <td />
              <td>{Utils.convKingaku(dt.koyonusiGoukei / dt.laborWorkDays)}</td>
            </tr>
            <tr>
              <td className='text-left' colSpan='2'>日額社会保険料(料率ベース)</td>
              <td />
              <td>{Utils.convKingaku(dt.laborUnitPrice - dt.laborTedoriUnitPrice)}</td>
              <td />
              <td>{Utils.convKingaku(dt.laborHukuriUnitPrice - dt.laborUnitPrice)}</td>
            </tr>
          </tbody>
        </table>

      </div>
    )
  }
}
export default SocialInsuranceUchiwake



// WEBPACK FOOTER //
// ./src/company_user/print/LaborUnitPriceTab/SocialInsuranceUchiwake.js